module.exports = {"id":"dp2_1l3q4","text":"Interacting Through Digital Technologies","instructions":"Which is a key limitation of virtual assistants in communication?","multiselect":false,"questionType":"PickOne","random":true,"options":[{"id":"dp2_1l3q4-a1","text":"They struggle with ambiguous intent","score":3.7},{"id":"dp2_1l3q4-a2","text":"They require no user input","score":1.3},{"id":"dp2_1l3q4-a3","text":"They fully replace human judgment","score":1.3}],"groupTitle":"Digital Profiler Knowledge Matrix","category":"2.1"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.1/l3q4.json
// module id = 995
// module chunks = 41